import { supabase } from '@/integrations/supabase/client';
import { useErrorHandler } from '@/hooks/useErrorHandler';
import { logger } from '@/utils/logger';

export const useResendConfirmation = () => {
  const { handleError } = useErrorHandler();

  const resendConfirmation = async (email: string) => {
    try {
      logger.debug('📧 Renvoi de l\'email de confirmation');
      
      // Détecter si on est sur mobile (Capacitor) ou web
      const isMobile = typeof window !== 'undefined' && (
        window.location.protocol === 'capacitor:' || 
        navigator.userAgent.includes('CapacitorWebView') ||
        !!window.Capacitor
      );
      
      // Configuration de l'URL de redirection selon la plateforme
      const redirectTo = isMobile
        ? 'octoveto://auth/callback'
        : `${window.location.origin}/auth/callback`;
      
      const { error } = await supabase.auth.resend({
        type: 'signup',
        email: email,
        options: {
          emailRedirectTo: redirectTo
        }
      });
      
      if (error) {
        logger.error('❌ Erreur renvoi confirmation:', error.message);
        return { error };
      }
      
      logger.debug('✅ Email de confirmation renvoyé avec succès');
      return { error: null };
      
    } catch (error) {
      logger.error('💥 Exception lors du renvoi:', error);
      handleError(error as Error, 'resend confirmation');
      return { error };
    }
  };

  return { resendConfirmation };
};
